//initialize new context
import { createContext } from 'react';

const documentUploadContext = createContext();

export default documentUploadContext;
